import { useState } from 'react';

/**
 * Hook to manage address search and geocoding for temporary locations
 */
export const useAddressGeocoding = () => {
  const [addressSearchQuery, setAddressSearchQuery] = useState('');
  const [addressSuggestions, setAddressSuggestions] = useState<any[]>([]);
  const [isSearchingAddress, setIsSearchingAddress] = useState(false);
  const [showCoordinates, setShowCoordinates] = useState(false);
  const [skipNextSearch, setSkipNextSearch] = useState(false);

  return {
    addressSearchQuery,
    setAddressSearchQuery,
    addressSuggestions,
    setAddressSuggestions,
    isSearchingAddress,
    setIsSearchingAddress,
    showCoordinates,
    setShowCoordinates,
    skipNextSearch,
    setSkipNextSearch,
  };
};
